"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = exports.CampusClient = exports.ExerciseClient = void 0;
var ExerciseClient_1 = require("./Clients/ExerciseClient");
Object.defineProperty(exports, "ExerciseClient", { enumerable: true, get: function () { return ExerciseClient_1.default; } });
var CampusClient_1 = require("./Clients/CampusClient");
Object.defineProperty(exports, "CampusClient", { enumerable: true, get: function () { return CampusClient_1.default; } });
var Actions_1 = require("./Actions");
Object.defineProperty(exports, "Actions", { enumerable: true, get: function () { return Actions_1.default; } });
__exportStar(require("./IExerciseContract"), exports);
//# sourceMappingURL=index.js.map